RivalIQ.apps.AdsInsights.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const PanelLoadData = {
        loadData: function () {
            const me = this;

            const attrs = App.utils.constructAdObjectMetric(me.getProps());
            const metric = new RivalIQ.models.MetricDefinition(attrs);

            let adLabelFetch;
            if (me.getProp('campaignAdLabel')) {
                const adLabelFetchAttrs = {
                    adAccountId: me.getProp('adAccountId')
                };
                adLabelFetch = RivalIQ.apps.AdsInsights.data.adLabels.fetch(adLabelFetchAttrs);
            }

            return $.when(metric.fetch(), adLabelFetch)
                .then(function (result, adLabels) {
                    me.adObject = result.getValue();
                    me.adLabels = adLabels;
                });
        }
    };

    const PanelTitle = RivalIQ.views.LayoutView.mixin({
        template: '#adsWidgetPngPanelTitleTemplate',
        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            loadData: PanelLoadData
        },

        regions: {
            breadcrumbs: '.x-breadcrumbs'
        },

        onRenderLoaded: function () {
            const me = this;
            me.showBreadcrumbs();
        },

        serializeData: function () {
            const me = this;

            let timePeriod = me.getProp('timePeriod');
            if (me.getProp('timePeriodType')) {
                timePeriod = RivalIQ.state.timePeriods.getByType(me.getProp('timePeriodType'));
            }

            return {
                title: me.dashboardModel.getTitle(),
                filters: App.utils.getFiltersDescription(me.getProps(), me.adLabels),
                timePeriod: RivalIQ.utils.timePeriod.getTimePeriodDisplayString(timePeriod)
            };
        },

        templateHelpers: function () {
            return RivalIQ.utils.emoji.getTemplateHelpers();
        },

        showBreadcrumbs: function () {
            const me = this;

            const adObject = me.adObject;

            const breadcrumbs = new App.views.Breadcrumbs({
                dashboardModel: me.dashboardModel,
                adObject: adObject,
                noLinks: true,
                showAccountName: true
            });

            me.breadcrumbs.show(breadcrumbs);
        }
    });

    views.PngPanel = RivalIQ.apps.Dashboard.views.PngPanel.extend({
        panelTitleView: PanelTitle
    });

    views.PdfPanel = RivalIQ.apps.Dashboard.views.PdfPanel.mixin({
        template: '#adsPDFWidgetTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            loadData: PanelLoadData
        },

        serializeData: function () {
            const me = this;

            const data = RivalIQ.apps.Dashboard.views.PdfPanel.prototype.serializeData.call(me, arguments);

            return _.extend(data, {
                filters: App.utils.getFiltersDescription(me.getProps(), me.adLabels)
            });
        }
    });
});
